import { LocalStorageUser } from '@utils/interfaces/localStorage';
import { LgSidebarUserProfile } from 'logical-growth-components';

export const resolveUserInitials = (displayName: string): string => {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return 'U';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const resolveUserProfile = (
  user: LocalStorageUser | null,
): LgSidebarUserProfile => {
  const displayName = user?.name?.trim() ?? '';
  return {
    displayName,
    initials: resolveUserInitials(displayName),
    subtitle: user?.email,
  };
};
